{
  "_note": "TRADUCTION À FAIRE VALIDER AVANT LA MISE EN PRODUCTION (relecture par un anglophone ou un traducteur ; texte juridique des mentions légales : relecture par un juriste).",
  "meta": {
    "title": "Megève International Horse Show 2027",
    "description": "Megève International Horse Show, in the heart of the village: 19–20 and 23–27 June 2027, free admission. National, Club, CSI4*, CSI2*, CSI1*.",
    "ogImageAlt": "Aiguille Croche, Megève"
  },
  "nav": {
    "language": "Language",
    "skip": "Skip to content",
    "concours": "The show",
    "programme": "Programme",
    "infos": "Practical info",
    "contact": "Contact",
    "sections": "Page sections",
    "menu": "Menu",
    "close": "Close menu"
  },
  "hero": {
    "riderAlt": "Rider jumping an obstacle",
    "title": "Megeve",
    "month": "June",
    "cta": "More information",
    "subtitle1": "International",
    "subtitle2": "- Horse Show -"
  },
  "form": {
    "title": "Information request",
    "firstname": "First name",
    "lastname": "Last name",
    "email": "Email",
    "phone": "Phone",
    "message": "Your message",
    "consent": "I agree that the data entered in this form may be processed in order to respond to my information request.",
    "consentLink": "Learn more about how my data is processed",
    "consentHref": "/mentions-legales.html#donnees",
    "submit": "Send",
    "errors": {
      "firstnameRequired": "Please enter your first name.",
      "firstnameMin": "Your first name must be at least 2 characters long.",
      "lastnameRequired": "Please enter your last name.",
      "lastnameMin": "Your last name must be at least 2 characters long.",
      "emailRequired": "Please enter your email address.",
      "emailInvalid": "This email address does not look valid.",
      "phoneInvalid": "Invalid phone number (e.g. 06 12 34 56 78 or +33 6 12 34 56 78).",
      "messageRequired": "Please enter your message.",
      "messageMin": "Your message must be at least 10 characters long.",
      "messageMax": "Your message cannot exceed 2000 characters.",
      "consentRequired": "You must accept the processing of your data to send your request."
    },
    "errorsSummary": "The form contains errors:"
  },
  "partners": {
    "label": "Partners and organisers",
    "ffe": "French Equestrian Federation"
  },
  "footer": {
    "copy": "© Megève International Horse Show",
    "madeWith": "Made with",
    "by": "by",
    "legal": "Legal notice"
  },
  "legal": {
    "metaTitle": "Legal notice, terms of use and privacy policy — Megève International Horse Show",
    "metaDescription": "Legal notice, terms of use, privacy policy and cookie policy of the website, including the processing of data submitted through the information request form.",
    "homeAlt": "Megève — back to home page"
  },
  "seo": {
    "nationalName": "Megève National and Club Show",
    "internationalName": "Megève International Show Jumping (CSI4*, CSI2*, CSI1*)"
  },
  "s": {
    "essentials": {
      "label": "At a glance",
      "free": "Free admission",
      "parking": "Free parking",
      "food": "Food and drink on site",
      "start": "First classes at 8:00 am*",
      "startNote": "*Times subject to change"
    },
    "village": {
      "title": "Megève International Horse Show, in the heart of the village!",
      "lead": "<strong>From 19 to 27 June 2027</strong>, the horse takes over the heart of the village of Megève, on the esplanade of the Palais des Sports, for a sporting and festive interlude opening the summer season.",
      "historyTitle": "Horses and Megève, a shared history",
      "historyText": "In Megève, the horse is part of the village's identity. Beyond top-level sport, the show will bring together residents, visitors, shopkeepers and professionals around an international event rooted in its territory, where the Megève Horse will have a special place.",
      "charmTitle": "The charm of an authentic village",
      "festiveTitle": "A festive get-together to enjoy as one",
      "festiveText": "Designed as a warm, festive event open to everyone, the show invites the public to discover the equestrian world <strong>free of charge</strong>. On <strong>Thursday and Friday</strong>, once night has fallen, two <strong>evenings</strong> combining sport and a festive atmosphere will be on offer, keeping the buzz going in the heart of Megève.",
      "activities": "The Megève International Horse Show is not only to be experienced from the stands. Around the arena and in the village, plenty of activities for young and old will be waiting to be discovered: <strong>pony rides</strong>, show-jumping courses with <strong>hobby horses</strong>, … so many ways to get close to the equestrian world in a fun and friendly way.",
      "guard": "The Garde républicaine will also be there for a one-of-a-kind parade in the heart of the village!"
    },
    "programme": {
      "title": "Programme",
      "year": "2027",
      "d1Days": "Sat. 19 - Sun. 20 June",
      "d1Label": "National & Club classes",
      "d2Days": "Wed. 23 - Sun. 27 June",
      "d2Label": "CSI4* - CSI2* - CSI1*",
      "eliteTitle": "The world's equestrian elite",
      "eliteSub": "brought together under 3 international labels",
      "teamTitle": "An outstanding course-design team",
      "team1": "<strong>The Megève International Horse Show</strong> will welcome many of the world's best riders for five days of intense competition, with a <strong>CSI4*</strong>, a <strong>CSI2*</strong> and a <strong>CSI1*</strong>.",
      "team2": "The highlight of the week: the <strong>4* Grand Prix, rated at 1.60 m</strong>, promises a summit clash between the best combinations of the weekend.",
      "team3": "To design the courses, the renowned <strong>Olympic course designer Grégory Bodo</strong> will lead an experienced team, ready to deliver a breathtaking sporting spectacle!",
      "preamble": "As a prelude to this international week, the village will come alive from the weekend before to the rhythm of the <strong>national and club classes</strong>. A friendly, formative first highlight, designed to showcase up-and-coming and regional riders on the same exceptional arena."
    },
    "welfare": {
      "title": "For the well-being of our horses",
      "text": "Equine welfare remains a <strong>priority</strong> for the Megève International Horse Show. The site will offer high-quality facilities: a Toubin & Clément sand arena, a covered paddock, an outdoor warm-up arena, a Havrincourt ring and stables with wooden flooring."
    },
    "info": {
      "title": "Practical information",
      "nationalLabel": "National & Club competitions",
      "nationalDates": "Saturday 19 and Sunday 20 June 2027",
      "intlLabel": "International competitions",
      "intlDates": "From Wednesday 23 to Sunday 27 June 2027",
      "venueLabel": "Venue",
      "venueName": "Palais des sports de Megève",
      "venueAddress1": "247 Route du Palais des Sports,",
      "venueAddress2": "74120 Megève, France",
      "directions": "Get directions"
    },
    "photos": {
      "v1": "Bird's-eye view of Megève and the surrounding mountains",
      "v2": "The village square, its round tower and horse-drawn carriages",
      "v3": "Megève's church and town-centre houses among the flowers",
      "v4": "The Megève valley seen from the meadows",
      "place": "Megève's village square, in flower and sunshine",
      "piste": "A rider clears a jump in the show arena",
      "welfare": "Close-up of a horse's head"
    }
  },
  "msg_send": "Thank you, your request has been sent. We will get back to you shortly.",
  "msg_not_send": "An error occurred while sending your message. Please try again later."
}
